(function () {
  'use strict';

  function findVariant(variants, optionValues) {
    return variants.find(function (v) {
      if (!v.options || v.options.length !== optionValues.length) return false;
      return v.options.every(function (opt, i) {
        return opt === optionValues[i];
      });
    });
  }

  function getRowSelects(wrapper) {
    return Array.from(wrapper.querySelectorAll('.cart-item__option-select'));
  }

  function setRowDisabled(wrapper, disabled) {
    getRowSelects(wrapper).forEach(function (s) {
      s.disabled = disabled;
    });
  }

  function restoreOriginalValues(wrapper) {
    getRowSelects(wrapper).forEach(function (s) {
      s.value = s.dataset.originalValue;
    });
  }

  function showError(wrapper, message) {
    var row = wrapper.closest('.cart-item');
    if (!row) return;
    var errorEl = row.querySelector('.cart-item__error-text');
    if (errorEl) errorEl.textContent = message;
  }

  function getVariants(wrapper) {
    var dataEl = wrapper.querySelector('.cart-item__variants-data');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function refreshAvailability(wrapper) {
    var variants = getVariants(wrapper);
    if (!variants) return;
    var selects = getRowSelects(wrapper);
    var currentValues = selects.map(function (s) { return s.value; });

    selects.forEach(function (select, position) {
      Array.from(select.options).forEach(function (option) {
        var baseLabel = option.dataset.label;
        if (!baseLabel) {
          baseLabel = option.textContent.replace(/\s*\(épuisé\)\s*$/, '').trim();
          option.dataset.label = baseLabel;
        }
        var testValues = currentValues.slice();
        testValues[position] = option.value;
        var match = findVariant(variants, testValues);
        var available = !!(match && match.available);
        option.disabled = !available;
        option.textContent = available ? baseLabel : baseLabel + ' (épuisé)';
      });
    });
  }

  function refreshAllAvailability(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cart-item-options]').forEach(refreshAvailability);
  }

  function refreshCartDrawer() {
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') {
      return items.onCartUpdate();
    }
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
      });
  }

  function refreshCartBubble() {
    return fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var target = document.getElementById('cart-icon-bubble');
        var source = doc.getElementById('cart-icon-bubble');
        if (target && source) target.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }

  function swapLineVariant(wrapper, newVariantId) {
    var line = parseInt(wrapper.dataset.line, 10);
    var quantity = parseInt(wrapper.dataset.quantity, 10) || 1;

    setRowDisabled(wrapper, true);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[line - 1];
        var properties = (item && item.properties) || {};
        var sellingPlan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? item.selling_plan_allocation.selling_plan.id
          : null;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 }),
        }).then(function (r) {
          if (!r.ok) throw new Error('remove failed');
          var body = { id: newVariantId, quantity: quantity, properties: properties };
          if (sellingPlan) body.selling_plan = sellingPlan;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
        });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error((err && err.description) || 'add failed');
          });
        }
        return Promise.all([refreshCartDrawer(), refreshCartBubble()]).then(function () {
          refreshAllAvailability();
        });
      })
      .catch(function (err) {
        restoreOriginalValues(wrapper);
        showError(wrapper, (err && err.message) || 'Erreur lors du changement de taille.');
        setRowDisabled(wrapper, false);
      });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('.cart-item__option-select');
    if (!select) return;

    var wrapper = select.closest('[data-cart-item-options]');
    if (!wrapper) return;

    var variants = getVariants(wrapper);
    if (!variants) return;

    var currentValues = getRowSelects(wrapper).map(function (s) {
      return s.value;
    });

    var match = findVariant(variants, currentValues);
    if (!match) {
      restoreOriginalValues(wrapper);
      showError(wrapper, 'Cette combinaison n’est pas disponible.');
      return;
    }
    if (!match.available) {
      restoreOriginalValues(wrapper);
      showError(wrapper, 'Cette taille est en rupture de stock.');
      return;
    }

    refreshAvailability(wrapper);
    swapLineVariant(wrapper, match.id);
  });

  function init() {
    refreshAllAvailability();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-cart-item-options]')) {
          refreshAvailability(node);
        } else if (node.querySelectorAll) {
          refreshAllAvailability(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
